// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loan-chances .loan-chances-title-container {
  display: flex;
  align-items: center;
  margin-bottom: 0.6rem;
}
#loan-chances .loan-chances-title-container .icon {
  margin-left: 0.4rem;
  color: var(--primary-text-color);
  font-size: 1rem;
}
#loan-chances .loan-chances-pointer-container {
  display: flex;
}
#loan-chances .loan-chances-pointer-container .loan-chances-pointer {
  width: 4.3rem;
  height: 0.24rem;
  margin-right: 0.26rem;
  border-radius: 10px;
  background-color: #c4c4c4;
}
#loan-chances .loan-chances-pointer-container .loan-chances-pointer .loan-chances-pointer-handler {
  width: 0rem;
  height: 0.24rem;
  border-radius: 10px;
  transition: 2s;
}
#loan-chances .loan-chances-pointer-container .loan-chances-pointer.active {
  animation: dad_level_up 4s ease-out;
}
#loan-chances .loan-chances-pointer-container .loan-chances-pointer.active .loan-chances-pointer-handler {
  width: 100%;
  animation: level_up 4s ease-out;
}
#loan-chances .loan-chances-pointer-container .loan-chances-pointer.active.color-danger .loan-chances-pointer-handler {
  background-color: var(--danger-color);
}
#loan-chances .loan-chances-pointer-container .loan-chances-pointer.active.color-warning .loan-chances-pointer-handler {
  background-color: var(--warning-color);
}
#loan-chances .loan-chances-pointer-container .loan-chances-pointer.active.color-more-warning .loan-chances-pointer-handler {
  background-color: var(--more-warning-color);
}
#loan-chances .loan-chances-pointer-container .loan-chances-pointer.active.color-success .loan-chances-pointer-handler {
  background-color: var(--success-color);
}
#loan-chances .loan-chances-pointer-container .loan-chances-pointer.active.color-primary .loan-chances-pointer-handler {
  background-color: var(--primary-button-color);
}
@media (max-width: 500px) {
  #loan-chances .loan-chances-pointer-container .loan-chances-pointer {
    width: 23%;
    margin-right: 2%;
  }
}
@keyframes level_up {
  50% {
    transform: scale(1);
    filter: brightness(100%);
  }
  60% {
    transform: scale(1.1);
    filter: brightness(150%);
  }
  70% {
    transform: scale(1.1);
    filter: brightness(150%);
  }
  80% {
    transform: scale(1);
    filter: brightness(100%);
  }
}
@keyframes dad_level_up {
  50% {
    transform: translateY(0px);
    box-shadow: 0 0 0 #0008;
  }
  60% {
    transform: translateY(-6px);
    box-shadow: 0 8px 6px #0006;
  }
  70% {
    transform: translateY(-6px);
    box-shadow: 0 8px 6px #0006;
  }
  80% {
    transform: translateY(0px);
    box-shadow: 0 0 0 #0008;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/others/LoanChances/styles.less"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,mBAAA;EACA,qBAAA;AAAJ;AAJA;EAOM,mBAAA;EACA,gCAAA;EACA,eAAA;AAAN;AATA;EAcI,aAAA;AAFJ;AAZA;EAgBM,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AADN;AAnBA;EAuBQ,WAAA;EACA,eAAA;EACA,mBAAA;EAEA,cAAA;AAFR;AAKM;EACE,mCAAA;AAHR;AAEM;EAII,WAAA;EACA,+BAAA;AAHV;AAMQ;EAEI,qCAAA;AALZ;AAQQ;EAEI,sCAAA;AAPZ;AAUQ;EAEI,2CAAA;AATZ;AAYQ;EAEI,sCAAA;AAXZ;AAcQ;EAEI,6CAAA;AAbZ;AAkBM;EAAA;IACE,UAAA;IACA,gBAAA;EAfN;AACF;AAqBA;EACE;IACE,mBAAA;IACA,wBAAA;EAnBF;EAqBA;IACE,qBAAA;IACA,wBAAA;EAnBF;EAqBA;IACE,qBAAA;IACA,wBAAA;EAnBF;EAqBA;IACE,mBAAA;IACA,wBAAA;EAnBF;AACF;AAqBA;EACE;IACE,0BAAA;IACA,uBAAA;EAnBF;EAqBA;IACE,2BAAA;IACA,2BAAA;EAnBF;EAqBA;IACE,2BAAA;IACA,2BAAA;EAnBF;EAqBA;IACE,0BAAA;IACA,uBAAA;EAnBF;AACF","sourcesContent":["#loan-chances {\n  .loan-chances-title-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: .6rem;\n\n    .icon {\n      margin-left: .4rem;\n      color: var(--primary-text-color);\n      font-size: 1rem;\n    }\n  }\n\n  .loan-chances-pointer-container {\n    display: flex;\n    .loan-chances-pointer {\n      width: 4.3rem;\n      height: .24rem;\n      margin-right: .26rem;\n      border-radius: 10px;\n      background-color: #c4c4c4;\n\n      .loan-chances-pointer-handler {\n        width: 0rem;\n        height: .24rem;\n        border-radius: 10px;\n\n        transition: 2s;\n      }\n\n      &.active {\n        animation: dad_level_up 4s ease-out;\n\n        .loan-chances-pointer-handler {\n          width: 100%;\n          animation: level_up 4s ease-out;\n        }\n\n        &.color-danger {\n          .loan-chances-pointer-handler {\n            background-color: var(--danger-color);\n          }\n        }\n        &.color-warning {\n          .loan-chances-pointer-handler {\n            background-color: var(--warning-color);\n          }\n        }\n        &.color-more-warning {\n          .loan-chances-pointer-handler {\n            background-color: var(--more-warning-color);\n          }\n        }\n        &.color-success {\n          .loan-chances-pointer-handler {\n            background-color: var(--success-color);\n          }\n        }\n        &.color-primary {\n          .loan-chances-pointer-handler {\n            background-color: var(--primary-button-color);\n          }\n        }\n      }\n\n      @media(max-width: 500px) {\n        width: 23%;\n        margin-right: 2%;\n      }\n\n    }\n  }\n}\n\n@keyframes level_up {\n  50% {\n    transform: scale(1);\n    filter: brightness(100%);\n  }\n  60% {\n    transform: scale(1.1);\n    filter: brightness(150%);\n  }\n  70% {\n    transform: scale(1.1);\n    filter: brightness(150%);\n  }\n  80% {\n    transform: scale(1);\n    filter: brightness(100%);\n  }\n}\n@keyframes dad_level_up {\n  50% {\n    transform: translateY(0px);\n    box-shadow: 0 0 0 #0008;\n  }\n  60% {\n    transform: translateY(-6px);\n    box-shadow: 0 8px 6px #0006;\n  }\n  70% {\n    transform: translateY(-6px);\n    box-shadow: 0 8px 6px #0006;\n  }\n  80% {\n    transform: translateY(0px);\n    box-shadow: 0 0 0 #0008;\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
